<script lang="ts" setup>
import appConfig from "./config/app.config";

import { useHead } from "@unhead/vue";
import { TuiProgressSpinner, TuiToast } from "@vm/tui";

import { pinia } from "./core/boot-app";
import { useSetupApp } from "./core/setup-app";

const { head } = appConfig;
useHead(head);

const { initialized, isBusy, friendlyError } = useSetupApp(pinia);
</script>

<template>
  <RouterView v-if="initialized" />
  <div v-if="isBusy" class="flex h-screen items-center justify-center">
    <TuiProgressSpinner text="Data laden..." />
  </div>
  <p v-if="friendlyError" class="p-4 text-center text-red-600">
    {{ friendlyError }}
  </p>
  <TuiToast position="bottom-center" />
</template>
